import PropTypes from "prop-types";

const ArrowDown = ({ size = 64, fill = "black" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.0621 16.127H28.8076C28.6228 16.127 28.446 16.2074 28.3215 16.348L19.5264 26.485V3.86049C19.5264 3.68371 19.3817 3.53906 19.2049 3.53906H16.7942C16.6174 3.53906 16.4728 3.68371 16.4728 3.86049V26.485L7.6777 16.348C7.55717 16.2074 7.38038 16.127 7.19154 16.127H3.93708C3.66386 16.127 3.5152 16.4525 3.69601 16.6574L17.0313 32.0257C17.1518 32.1647 17.3008 32.2763 17.4683 32.3527C17.6357 32.4291 17.8176 32.4687 18.0016 32.4687C18.1856 32.4687 18.3675 32.4291 18.5349 32.3527C18.7023 32.2763 18.8514 32.1647 18.9719 32.0257L32.3031 16.6574C32.484 16.4484 32.3353 16.127 32.0621 16.127Z"
      fill={fill}
    />
  </svg>
);

ArrowDown.defaultProps = {
  size: 64,
  fill: "black",
};

ArrowDown.propTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
};

export default ArrowDown;
